import { GameState, GamePhase } from '../types';

const EXTRA_LIFE_THRESHOLD = 10000;

export function createInitialState(totalCheese: number): GameState {
  return {
    phase: GamePhase.Ready,
    score: 0,
    lives: 3,
    level: 1,
    cheeseRemaining: totalCheese,
    totalCheese,
    comboMultiplier: 1,
    extraLifeAwarded: false,
  };
}

export function addCheeseScore(state: GameState): GameState {
  const score = state.score + 10;
  const lives = !state.extraLifeAwarded && score >= EXTRA_LIFE_THRESHOLD
    ? state.lives + 1
    : state.lives;
  return {
    ...state,
    score,
    lives,
    extraLifeAwarded: state.extraLifeAwarded || score >= EXTRA_LIFE_THRESHOLD,
    cheeseRemaining: state.cheeseRemaining - 1,
  };
}

export function addPowerCheeseScore(state: GameState): GameState {
  return {
    ...state,
    score: state.score + 50,
    cheeseRemaining: state.cheeseRemaining - 1,
    comboMultiplier: 1,
  };
}

export function addCatPounceScore(state: GameState): GameState {
  const points = 200 * state.comboMultiplier;
  const score = state.score + points;
  const lives = !state.extraLifeAwarded && score >= EXTRA_LIFE_THRESHOLD
    ? state.lives + 1
    : state.lives;
  return {
    ...state,
    score,
    lives,
    extraLifeAwarded: state.extraLifeAwarded || score >= EXTRA_LIFE_THRESHOLD,
    comboMultiplier: state.comboMultiplier * 2,
  };
}

export function addTreatScore(state: GameState, points: number): GameState {
  return {
    ...state,
    score: state.score + points,
  };
}

export function loseLife(state: GameState): GameState {
  const lives = state.lives - 1;
  return {
    ...state,
    lives,
    phase: lives <= 0 ? GamePhase.GameOver : GamePhase.Dying,
  };
}

export function nextLevel(state: GameState, totalCheese: number): GameState {
  return {
    ...state,
    level: state.level + 1,
    cheeseRemaining: totalCheese,
    totalCheese,
    comboMultiplier: 1,
    phase: GamePhase.Ready,
  };
}
